import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Translation } from 'react-i18next';
import {
  fetchMenuLinksList,
  addImagesToMenusItem,
  clearAddImagesToMenusItem,
  deleteImageFromMenusItem,
  clearDeleteImageFromMenusItem,
} from 'redux/menu-links/actions';
import CommonImageDropzone from 'components/common/CommonImageDropzone';
import CommonMessage from 'components/common/CommonMessage';
import { RESIZE_URL } from 'utils/restapi';
import { Link } from 'react-router-dom';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import ProLabel from 'components/common/ProLabel';
import { connect } from 'react-redux';

import './MenusImageDropZone.css';

class MenusImageDropZone extends Component {
  static propTypes ={
    fetchMenuLinksList: PropTypes.func.isRequired,
    addImagesToMenusItem: PropTypes.func.isRequired,
    clearAddImagesToMenusItem: PropTypes.func.isRequired,
    deleteImageFromMenusItem: PropTypes.func.isRequired,
    clearDeleteImageFromMenusItem: PropTypes.func.isRequired,
    me: PropTypes.object,
    item: PropTypes.object.isRequired,
    addImageSuccess: PropTypes.object,
    addImagesError: PropTypes.object,
    deleteImageSuccess: PropTypes.object,
  }

  static defaultProps = {
    me: null,
    addImageSuccess: null,
    addImagesError: null,
    deleteImageSuccess: null,
  };

  componentDidUpdate(prevProps) {
    // Add Image
    if (!prevProps.addImagesSuccess && this.props.addImagesSuccess) {
      this.props.fetchMenuLinksList();
      this.props.clearAddImagesToMenusItem();
    }

    // Delete Image
    if (!prevProps.deleteImagesSuccess && this.props.deleteImagesSuccess) {
      this.props.fetchMenuLinksList();
      this.props.clearDeleteImageFromMenusItem();
    }
  }

  componentWillUnmount() {
    this.props.clearAddImagesToMenusItem();
    this.props.clearDeleteImageFromMenusItem();
  }

  onImageDrop = (droppedImages) => {
    const form = new FormData();
    this.props.item.media_items &&
      this.props.item.media_items.length > 0 &&
      this.props.item.media_items.forEach((item) =>
        form.append('images', item.id)
      );
    droppedImages.forEach((item) =>
      form.append('images', item.imageBlob, item.name)
    );
    this.props.addImagesToMenusItem(this.props.item.id, form);
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onReorderEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = this.reorder(
      this.props.item.media_items,
      result.source.index,
      result.destination.index
    );

    const form = new FormData();
    reorderedItems.forEach((item) => form.append('images', item.id));
    this.props.addImagesToMenusItem(this.props.item.id, form);
  };

  renderImageList = () => {
    return (
      this.props.item.media_items && (
        <DragDropContext onDragEnd={this.onReorderEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div
                className="droppable-container"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {this.props.item.media_items.map((item, index) => {
                  return (
                    <Draggable
                      key={`${item.id}`}
                      draggableId={`${item.id}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div
                            className="image"
                            style={{ backgroundImage: item.image &&
                                `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=90/${item.image})`
                            }}
                          >
                            <div
                              className="delete-icon"
                              onClick={() => {
                                this.props.deleteImageFromMenusItem(item.id);
                                this.props.clearAddImagesToMenusItem();
                              }}
                              role="button"
                              tabIndex={-1}
                            />
                          </div>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )
    );
  };

  calculateAspectRatio = () => {
    if (this.props.item.image_size === 'SQ') {
      return 1 / 1;
    }
    if (this.props.item.image_size === 'HR') {
      return 4 / 3;
    }
    if (this.props.item.image_size === 'VR') {
      return 3 / 4;
    }
    return 1 / 1;
  };

  render() {
    const { me, item, addImagesError } = this.props;
    const locked = me && me.subscription && !me.subscription.ff_menu;
    return (
      <ProFeaturePlaceholder
      locked={locked}
      noKeyIcon
      >
        <Translation>
          {(t) => (<div className="menus-image-dropzone__component">
            <div className="dropzone-wrapper">
              {/* Dropzone */}
              <CommonImageDropzone
                onDropImage={this.onImageDrop}
                className="upload-dropzone"
                modalClassName="image-slider-upload-dropzone"
                multiple
                maxFiles={10}
                aspectRatio={this.calculateAspectRatio()}
              >
                <div className="dropzone-text">
                  {t('Drop your images here, or just')} <span>{t('Browse')}</span>{' '}
                  {t('your local storage')}
                </div>
                {!(item && item.media_items && item.media_items.length > 0) && (
                  <div className="buttons-block">
                    <div className="btn-title">+ {t("Upload Image")}</div>
                    <ProLabel/>
                  </div>
                )}
              </CommonImageDropzone>
    
              {/* Images Container */}
              <div className="images-container">
                {this.renderImageList()}
              </div>
    
              {addImagesError && (
                <CommonMessage error>
                  {t('You can add 10 images on the PRO plan.')}
                  {t('Check it')} <Link to="/billing">{t('here')}</Link>
                </CommonMessage>
              )}
            </div>
          </div>)}
        </Translation>
      </ProFeaturePlaceholder>
    );
  }
}

const mapStateToProps = (state) => ({
  me: state.usersReducer.me,
  addImagesSuccess: state.menuLinksReducer.addImagesSuccess,
  addImagesError: state.menuLinksReducer.addImagesError,
  deleteImagesSuccess: state.menuLinksReducer.deleteImagesSuccess,
});

export default connect(mapStateToProps, {
  fetchMenuLinksList,
  addImagesToMenusItem,
  deleteImageFromMenusItem,
  clearAddImagesToMenusItem,
  clearDeleteImageFromMenusItem,
})(MenusImageDropZone);
